import { render, staticRenderFns } from "./LeaderboardView.vue?vue&type=template&id=5767a30c&scoped=true"
import script from "./LeaderboardView.vue?vue&type=script&lang=js"
export * from "./LeaderboardView.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardView.vue?vue&type=style&index=0&id=5767a30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5767a30c",
  null
  
)

export default component.exports